import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { OuterTextWrapperProps } from '@widgets/Teaser/toi/types'
import { layout, desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

interface StyledOuterTextWrapperProps
  extends Pick<OuterTextWrapperProps, 'hasNewsticker'>,
    Pick<TOITeaserLayoutContextType, 'teaserFlex' | 'articleType'> {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']
}

const { TOITeaserLayoutContext } = contextToiTeaser

const {
  desktop: { minWidth: minWidthDesktop },
  tablet: { minWidth: minWidthTablet },
} = layout

const StyledOuterTextWrapper = styled.div<StyledOuterTextWrapperProps>`
  ${({ teaserFlex, alignment, articleType, hasNewsticker }) => {
    const desktopTeaserFlex = teaserFlex['desktop']
    const cornerPaddingDesktop = `${Math.round(
      (1.6 / 100) * minWidthDesktop
    )}px`
    const cornerPaddingTablet = `${Math.round((1.6 / 100) * minWidthTablet)}px`
    const cornerPaddingMobile = '3.7vw'

    return css`
      display: grid;
      grid-auto-flow: row;
      position: absolute;
      box-sizing: border-box;
      justify-self: ${alignment.h === 'left' ? 'flex-start' : 'flex-end'};
      ${alignment.h}: 0;
      ${articleType !== 'default' &&
      css`
        position: absolute;
        top: 0;
        ${alignment.h}: 0;
        height: 100%;
      `};

      ${desktopCSS(css`
        ${
          desktopTeaserFlex === '6'
            ? css`
                width: 64.3%;
              `
            : css`
                width: 100%;
              `
        };
        padding-${
          alignment.v === 'top' ? 'top' : 'bottom'
        }: ${cornerPaddingDesktop};
        ${
          articleType !== 'default' &&
          css`padding-${
            alignment.v === 'top' ? 'bottom' : 'top'
          }: ${cornerPaddingDesktop};`
        };
        ${alignment.v}: ${hasNewsticker ? '85px' : '0'};
        `)}

      ${tabletCSS(css`
        width: 100%;
        padding-${
          alignment.v === 'top' ? 'top' : 'bottom'
        }: ${cornerPaddingTablet};
        ${
          articleType !== 'default' &&
          css`padding-${
            alignment.v === 'top' ? 'bottom' : 'top'
          }: ${cornerPaddingTablet};`
        };
        ${alignment.v}: ${hasNewsticker ? '85px' : '0'};
      `)}

      ${mobileCSS(css`
        width: 100%;
        ${alignment.v}: 0;
        padding-${
          alignment.v === 'top' ? 'top' : 'bottom'
        }: ${cornerPaddingMobile};
        ${
          articleType !== 'default' &&
          css`padding-${
            alignment.v === 'top' ? 'bottom' : 'top'
          }: ${cornerPaddingMobile};`
        };
        ${alignment.v}: 0;
      `)}
    `
  }}
`

const OuterTextWrapper: FunctionComponent<OuterTextWrapperProps> = ({
  children,
  hasNewsticker,
}) => {
  const { teaserFlex, mainTextAlignment, articleType } = useContext(
    TOITeaserLayoutContext
  )

  return (
    <StyledOuterTextWrapper
      teaserFlex={teaserFlex}
      alignment={mainTextAlignment}
      articleType={articleType}
      hasNewsticker={hasNewsticker}>
      {children}
    </StyledOuterTextWrapper>
  )
}

export default OuterTextWrapper
